// extracted by mini-css-extract-plugin
export default {"container":"error-page_container"};